export default __webpack_public_path__ + "static/media/Scope-1.e6cc6a16.png";